import { render, staticRenderFns } from "./DepositDetailOffTemp.vue?vue&type=template&id=64d72518&scoped=true"
import script from "./DepositDetailOffTemp.vue?vue&type=script&lang=js"
export * from "./DepositDetailOffTemp.vue?vue&type=script&lang=js"
import style0 from "./DepositDetailOffTemp.vue?vue&type=style&index=0&id=64d72518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d72518",
  null
  
)

export default component.exports